import { render } from "./RegisterStatisticView.vue?vue&type=template&id=4ab2169c&scoped=true"
import script from "./RegisterStatisticView.vue?vue&type=script&lang=js"
export * from "./RegisterStatisticView.vue?vue&type=script&lang=js"

import "./RegisterStatisticView.vue?vue&type=style&index=0&id=4ab2169c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab2169c"]])

export default __exports__